import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

const useOneLinkSmartScriptV2 = (options) => {
  const baseLink = 'https://unacademy.onelink.me/RICs/';
  const [oneLinkURL, setoneLinkURL] = useState(null);
  const { asPath } = useRouter();

  const generateLink = () => {
    const mediaSource = {
      keys: [],
      defaultValue: ['Mweb_download']
    };
    const campaign = {
      keys: [],
      defaultValue: [options?.campaign || 'Mweb']
    };
    const deepLinkValue = { keys: [], defaultValue: asPath.slice(1) };
    const deep_link_sub1 = {
      paramKey: 'deep_link_sub1',
      keys: [],
      defaultValue: 'app_deeplink'
    };
    const af_dp = {
      paramKey: 'af_dp',
      keys: [],
      defaultValue: 'unacademy://plus'
    };
    const result = window.AF_SMART_SCRIPT.generateOneLinkURL({
      oneLinkURL: baseLink,
      afParameters: {
        mediaSource,
        campaign,
        deepLinkValue,
        afCustom: [deep_link_sub1, af_dp]
      }
    });
    if (result) {
      setoneLinkURL(result.clickURL);
    }
  };

  useEffect(() => {
    const delay = window.AF_SMART_SCRIPT ? 0 : 1000;
    setTimeout(() => {
      generateLink();
    }, delay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [asPath, baseLink, options]);

  return oneLinkURL;
};

export default useOneLinkSmartScriptV2;
